export const frequency = [
  "- Select Frequency -",
  "Weekly",
  "Bi-Weekly",
  "Monthly",
  "Quarterly",
  "Annually"
]